import { createVNode as _createVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0eee9705")

_pushScopeId("data-v-0eee9705")
const _hoisted_1 = { class: "flex items-center flex-col pt-6" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_QuestionNext = _resolveComponent("QuestionNext")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("textarea", {
      class: "\n      flex\n      cursor-pointer\n      bg-white\n      items-center\n      py-3\n      px-5\n      border-solid border-2\n      w-full\n      textarea\n    ",
      rows: "5",
      onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args))),
      value: _ctx.currentAnswer
    }, null, 40, ["value"]),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_QuestionNext, { onNext: _ctx.onNext }, null, 8, ["onNext"])
    ])
  ], 64))
})